var Q = require('q')

const state = {
  // notFound: false
  loading: false,
  isProcessing: false
}

const getters = {
  // notFound: (state) => state.notFound
  loading: (state) => state.loading,
  isProcessing: (state) => state.isProcessing
}

const mutations = {
  /* SET_NOT_FOUND (state, status) {
    state.notFound = status
  } */
  SET_LOADING (state, isLoading) {
    state.loading = isLoading
  },

  SET_IS_PROCESSING (state, isProcessing) {
    state.isProcessing = isProcessing
  }
}

const actions = {
  /* notFoundPage ({ commit }, status) {
    commit('SET_NOT_FOUND', status)
  }, */

  init ({ commit, dispatch, rootGetters }) {
    if (rootGetters['auth/accessToken']) {
      console.log('---INIT DATA---')
      commit('SET_LOADING', true)

      let promises = []

      promises.push(dispatch('file/getFiles', null, { root: true }))
      promises.push(dispatch('file/getFileTypes', null, { root: true }))
      promises.push(dispatch('region/getRegions', null, { root: true }))

      Q.all(promises).then(() => {
        commit('SET_LOADING', false)
      }).catch((error) => {
        console.error(`Error init data ${error}`)
        commit('SET_LOADING', false) // TODO Saltar error
      })
    }
  },

  setLoading ({ commit, dispatch }, isLoading) {
    commit('SET_LOADING', isLoading)
  },

  setIsProcessing ({ commit, dispatch }, isProcessing) {
    commit('SET_IS_PROCESSING', isProcessing)
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
